import { BooleanCons, RolesString } from 'src/app/constants/const';
import { CallPlace } from '../http/myActivity.model';

export interface Visualization{
  getVisualizationParams(): VisualizationParams;
}

export class VisualizationParams{
  isHeader: boolean;
  isContentEmpty: boolean;
  isLockButton: boolean;
  isDiscountVisible: boolean;
  isdisableCostDiscount: boolean;
  isNeedDataTax: boolean;
  isShippingCost: boolean;
  isViewAddToCar: boolean;
  isUtility: boolean;
  isDisableUtilities: boolean;
  isPaymentAuthorized: boolean;
  informationIsloaded: boolean;
  showPickedUp: boolean;
  showDialogDiscount = BooleanCons.true;
  showIvaLegend: boolean;
  isPendingOrder: boolean;
  isActiveOrders: boolean;
  constructor(){
    this.informationIsloaded = BooleanCons.false;
    this.showPickedUp = BooleanCons.false;
    this.showDialogDiscount = BooleanCons.true;
    this.showIvaLegend = BooleanCons.false;
    this.isHeader =  BooleanCons.false;
    this.isViewAddToCar =  BooleanCons.false;
    this.isDiscountVisible = BooleanCons.true;
    this.isdisableCostDiscount = BooleanCons.true;
    this.isContentEmpty = BooleanCons.false;
    this.isLockButton = BooleanCons.false;
    this.isNeedDataTax = BooleanCons.false;
    this.isShippingCost = BooleanCons.false;
    this.isUtility = BooleanCons.false;
    this.isDisableUtilities = BooleanCons.false;
    this.isPaymentAuthorized = BooleanCons.false;
    this.isPendingOrder = BooleanCons.false;
    this.isActiveOrders = BooleanCons.false;
  }
}

export class VisualizationParamsFromDetailOrdersList implements Visualization{
  constructor(){
  }
  getVisualizationParams(): VisualizationParams{
    const visualization = new VisualizationParams();
    visualization.isDiscountVisible = BooleanCons.true;
    visualization.isdisableCostDiscount = BooleanCons.true;
    visualization.isHeader = BooleanCons.true;
    visualization.showPickedUp = BooleanCons.true;
    visualization.showDialogDiscount = BooleanCons.false;
    return visualization;
  }
}
export class VisualizationParamsFromDetailOrdersListEdit implements Visualization{
  constructor(){
  }
  getVisualizationParams(): VisualizationParams{
    const visualization = new VisualizationParams();
    visualization.isDiscountVisible = BooleanCons.true;
    visualization.isdisableCostDiscount = BooleanCons.true;
    visualization.showIvaLegend = BooleanCons.true;
    visualization.isUtility = BooleanCons.true;
    visualization.isDisableUtilities = BooleanCons.true;
    visualization.informationIsloaded = BooleanCons.true;
    return visualization;
  }
}
export class VisualizationParamsFromPendingOrders implements Visualization{
  rol: string;
  constructor(rol: string) {
    this.rol = rol;
  }
  getVisualizationParams(): VisualizationParams{
    const visualization = new VisualizationParams();
    visualization.isDiscountVisible = BooleanCons.true;
    visualization.isdisableCostDiscount = BooleanCons.true;
    visualization.isHeader = BooleanCons.true;
    visualization.isViewAddToCar = this.rol === RolesString.advisor;
    visualization.isPendingOrder = true;
    visualization.showPickedUp = BooleanCons.true;
    visualization.showDialogDiscount = BooleanCons.true;
    return visualization;
  }
}

export class VisualizationParamsFromActiveOrders implements Visualization{
  rol: string;
  constructor(rol: string) {
    this.rol = rol;
  }
  getVisualizationParams(): VisualizationParams{
    const visualization = new VisualizationParams();
    visualization.isDiscountVisible = BooleanCons.true;
    visualization.isdisableCostDiscount = BooleanCons.true;
    visualization.isHeader = BooleanCons.true;
    visualization.isViewAddToCar = this.rol === RolesString.advisor;
    visualization.isActiveOrders = true;
    visualization.showPickedUp = BooleanCons.true;
    visualization.showDialogDiscount = BooleanCons.true;
    return visualization;
  }
}

export class VisualizationParamsFromDefault implements Visualization{
  sameCardCode: boolean;
  constructor(sameCardCode: boolean){
    this.sameCardCode = sameCardCode;
  }
  getVisualizationParams(): VisualizationParams{
    const visualization = new VisualizationParams();
    visualization.isDiscountVisible = BooleanCons.true;
    visualization.isdisableCostDiscount = BooleanCons.true;
    visualization.isUtility = BooleanCons.true;
    visualization.isDisableUtilities = BooleanCons.true;
    visualization.informationIsloaded = this.sameCardCode;
    return visualization;
  }
}
